import { environment as devEnv } from '@environments/environment';
import { environment as prodEnv } from '@environments/environment.prod';
import { AuthConfig } from 'angular-oauth2-oidc';

const isLocalEnv = window.location.host.includes('localhost');

const issuer = isLocalEnv
    ? devEnv.endpoints.identity
    : prodEnv.endpoints.identity;

const redirectUri = isLocalEnv
    ? `${devEnv.endpoints.baseUrl}/index.html`
    : `${prodEnv.endpoints.baseUrl}/index.html`;

const postLogoutRedirectUri = isLocalEnv
    ? `${devEnv.endpoints.baseUrl}/index.html`
    : `${prodEnv.endpoints.baseUrl}/index.html`;

export const authCodeFlowConfig: AuthConfig = {
    issuer,
    redirectUri,
    postLogoutRedirectUri,
    clientId: 'admin.client',
    responseType: 'code',
    scope: 'openid profile api userinfo offline_access',
    showDebugInformation: false,
    useSilentRefresh: true,
};
